const google_map_key = "AIzaSyC3SNaei5jnL7IVFwyrotWzfpEa5Hsntao";

export { google_map_key };
